<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="search-outline"></nb-icon>
        <div class="ml-2" i18n>Viewing Robot: {{ robot.id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 800px">
    <h5 class="mb-0" i18n>General Information</h5>
    <hr />

    <div class="row mb-5">
      <div class="col">
        <div class="field-label" i18n>Name</div>
        <div>{{ robot.name }}</div>
        <div class="field-label mt-3" i18n>SKU</div>
        <div>{{ robot.sku }}</div>
        <div class="field-label mt-3" i18n>Serial Number</div>
        <div>{{ robot.serial_number || '-' }}</div>
      </div>
      <div class="col">
        <div class="field-label" i18n>Timezone</div>
        <div>{{ robot.timezone }}</div>
        <div class="field-label mt-3" i18n>Registration Date</div>
        <div>{{ robot.registration_date | customValueHandling: 'registration_date' }}</div>
      </div>
    </div>
  </nb-card-body>
</nb-card>
